<template>
  <logo-header v-if="displayLogoInHeader" :url="logoUrl" :name="name"></logo-header>
  <logo-middle v-else :url="logoUrl" :name="name"></logo-middle>
</template>

<script>
import Vue from 'vue'
import Router from 'vue-router'
import ImageJarvisLogo from '../../assets/images/logo-xl.png'
import LawFirmApi from '../../api/public-law-firm'
import { mapGetters } from 'vuex'
import LogoMiddle from './LogoMiddle.vue'
import LogoHeader from './LogoHeader.vue'

Vue.use(Router)

export default {
  props: {
    position: {
      type: String,
      required: false,
      default: 'middle'
    }
  },
  data () {
    return {
      logoUrl: null,
      name: null
    }
  },
  computed: {
    ...mapGetters('user', [
      'isLogged'
    ]),
    displayLogoInHeader () {
      return this.position === 'header'
    }
  },
  methods: {
    getLogoUrl () {
      let lawFirmId = null

      if (this.isLogged) {
        if (this.$store.getters.currentLawFirm !== undefined) {
          lawFirmId = this.$store.getters.currentLawFirm.id
        }
      } else {
        lawFirmId = this.$route.query.law_firm_id
      }

      if (lawFirmId) {
        LawFirmApi.getLogoUrl(lawFirmId)
          .then(res => {
            if (res.data.logoUrl) {
              this.logoUrl = res.data.logoUrl
              this.name = res.data.name
            }
          })
          .catch(() => {
            this.setDefaultLogo()
          })

        return
      }

      this.setDefaultLogo()
    },
    setDefaultLogo () {
      this.logoUrl = ImageJarvisLogo
      this.name = 'Jarvis Legal'
    }
  },
  mounted () {
    this.getLogoUrl()
  },
  components: {
    LogoHeader,
    LogoMiddle
  }
}
</script>
